<script setup lang="ts">
import { CloudProviderType } from 'gpcore-grpc/gpcore/type/v1/cloud_provider_pb';
import TencentMonoIcon from 'gpcore-uikit/icons/mono/tencent.vue';
import AwsMonoIcon from 'gpcore-uikit/icons/mono/aws.vue';
import GpcoreMonoIcon from 'gpcore-uikit/icons/mono/gpcore.vue';
import { GpTooltip } from '@gportal/uikit';

defineProps<{
  nodeId: string;
  cloudProvider?: CloudProviderType;
  title: string;
}>();
</script>

<template>
  <router-link
    :to="{
      name: 'ProjectNodeOverview',
      params: {
        id: nodeId,
      },
    }"
  >
    <GpTooltip
      v-if="cloudProvider === CloudProviderType.TENCENT"
      content="This node is imported from Tencent cloud."
    >
      <TencentMonoIcon class="tw-mr-1 tw-inline-block tw-size-4" />
    </GpTooltip>
    <GpTooltip
      v-else-if="cloudProvider === CloudProviderType.AWS"
      content="This node is imported from AWS."
    >
      <AwsMonoIcon class="tw-mr-1 tw-inline-block tw-size-4" />
    </GpTooltip>
    <GpcoreMonoIcon v-else class="tw-mr-1 tw-inline-block tw-size-4" />

    {{ title }}
  </router-link>
</template>

<style scoped></style>
